import Vue from "vue";
import Router, { Route } from "vue-router";

import Home from "@/views/Home.vue";
import Stores from "@/views/stores/Index.vue";
import StoresTop from "@/views/stores/Top.vue";

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
        },
        {
            path: "/:storeName",
            component: Stores,
            children: [
                {
                    path: "",
                    component: StoresTop,
                    props: (route: Route) => ({ showSurvey: route.query.showSurvey === undefined ? true : false }),
                },
            ],
        },
    ],
});
